//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import scroll from '@/mixins/scroll'
import ElLink from '@/components/UI/el-link'
import AButton from './components/button/button.vue'
const Entities = require('html-entities').AllHtmlEntities

export default {
  name: 'CoursesSection',
  components: { AButton, ElLink },
  mixins: [scroll],
  data() {
    return {
      coding: [],
    }
  },
  mounted() {
    let cards = this.$getBullets('_courseCards')
    cards = cards.filter((card) => card.url && card.url.includes('/coding'))

    const coding = []
    cards.forEach((item) => {
      if (item.is_active === 1 || item.is_active === '1') {
        const courseInfo = this.getCourseInfo(item.url) || {
          class: 'violet',
          courseName: 'pytpro',
        }

        const temp = {}
        temp.title = Entities.decode(item.title)
        temp.description = Entities.decode(item.description)
        temp.name = courseInfo.courseName || 'pytpro'
        temp.img = courseInfo.courseName + '.svg'
        temp.age = Entities.decode(item.childrens_age)
        temp.url = item.url
        temp.class = courseInfo.class
        temp.shareIcon = courseInfo.shareIcon || 'white'
        temp.position = +item.position
        coding.push(temp)
      }
    })
    this.coding = coding.sort(function (a, b) {
      return a.position > b.position ? 1 : b.position > a.position ? -1 : 0
    })
  },
  methods: {
    getCourseInfo(url) {
      if (url.includes('pc')) {
        return { class: 'blue', courseName: 'pc', shareIcon: 'violet' }
      }
      if (url.includes('junior')) {
        return { class: 'yellow', courseName: 'junior', shareIcon: 'violet' }
      }
      if (url.includes('pytpro')) {
        return { class: 'violet', courseName: 'pytpro', shareIcon: 'white' }
      }
      if (url.includes('pytstart')) {
        return { class: 'purple', courseName: 'pytstart', shareIcon: 'white' }
      }
      if (url.includes('camp')) {
        return { class: 'lightBlue', courseName: 'camp', shareIcon: 'violet' }
      }
      if (url.includes('websites')) {
        return { class: 'green', courseName: 'websites', shareIcon: 'violet' }
      }
      if (url.includes('gamedesign')) {
        return {
          class: 'orange',
          courseName: 'gamedesign',
          shareIcon: 'violet',
        }
      }
      if (url.includes('videocontent')) {
        return {
          class: 'pink',
          courseName: 'videocontent',
          shareIcon: 'violet',
        }
      }
      if (url.includes('graphicdesign')) {
        return { class: 'red', courseName: 'graphicdesign', shareIcon: 'white' }
      }
      if (url.includes('creative')) {
        return { class: 'dk-pink', courseName: 'creative', shareIcon: 'white' }
      }
      if (url.includes('unity')) {
        return { class: 'dk-green', courseName: 'unity', shareIcon: 'white' }
      }
      if (url.includes('frontend')) {
        return { class: 'frontend', courseName: 'frontend', shareIcon: 'white' }
      }
    },
    handleCardClick(event) {
      if (!event.target.classList.contains('courses__list-item-title')) {
        this.smoothVerticalScrolling('#signup')
      }
    },
  },
}
